module.exports = __webpack_public_path__ + "static/img/icon-kf.7f04840.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon-kf.png
// module id = otwe
// module chunks = 0